// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__WwAf0","colCheckbox":"styles_colCheckbox__1KSwH"};